// extracted by mini-css-extract-plugin
module.exports = {"orderStatus":"OrderStatus_orderStatus__1nxLu","alertIcon":"OrderStatus_alertIcon__1qgwn","orderStatusDescription":"OrderStatus_orderStatusDescription__2unkt"};